import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";

export const addSkill = async (payload) => {
  try {
    const { data } = await axios.post(api.addSkill, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const searchSkill = async (searchText, filters = {}) => {
  try {
    const params = {};
    if (filters?.classification) {
      params.classification = filters.classification;
    }
    if (filters?.subClassification) {
      params.subClassification = Array.isArray(filters.subClassification)
        ? filters.subClassification.filter(Boolean)
        : [filters.subClassification];
    }

    const { data } = await axios.get(
      api.skillSearch + `/${encodeURIComponent(searchText)}`,
      { params }
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateSkill = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateSkill, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteSkill = async (SkillId) => {
  try {
    const { data } = await axios.delete(api.deleteSkill + SkillId);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getSkills = async (payload) => {
  try {
    const type = payload?.type || 1;
    const { candidateId, jobId, jobRequirementId, focusedOnly } = payload || {};
    const params = new URLSearchParams();
    params.append("type", type.toString());
    if (jobId) params.append("jobId", jobId);
    if (candidateId) params.append("candidateId", candidateId);
    if (jobRequirementId) params.append("jobRequirementId", jobRequirementId);
    if (focusedOnly) params.append("focusedOnly", "true");
    const { data } = await axios.get(api.listSkill + `?${params.toString()}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateSkillFocus = async (skillId, isFocused) => {
  try {
    const { data } = await axios.patch(
      `${api.updateSkillFocus}/${skillId}`,
      { isFocused },
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getMatchedCandidates = async (payload) => {
  try {
    const { data } = await axios.post(api.getMatchedCandidate, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralMatchedCandidates = async () => {
  try {
    const { data } = await axios.get(api.referralMatchedContacts);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralMatchedContactDetails = async (id) => {
  try {
    const { data } = await axios.get(
      api.referralMatchedContactDetails + `/${id}`
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getSkillIndividualPercentage = async (payload) => {
  try {
    const { data } = await axios.post(
      api.getSkillIndividualPercentage,
      payload
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};
